import * as React from 'react';
import { BaseSvg, SVGIconProps } from './BaseSvg';

export const NonActiveArtist: React.FC<SVGIconProps> = ({ size = 24, color = '#262E3F', ...props }) => (
  <BaseSvg width={size} height={size} viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#clip0_545_57971)">
      <path
        d="M9.74004 7.31073C9.98125 6.57731 11.0187 6.57731 11.26 7.31073L12.4774 11.0126C12.5568 11.2539 12.7461 11.4432 12.9874 11.5226L16.6893 12.74C17.4227 12.9813 17.4227 14.0187 16.6893 14.26L12.9874 15.4774C12.7461 15.5568 12.5568 15.7461 12.4774 15.9874L11.26 19.6893C11.0187 20.4227 9.98125 20.4227 9.74004 19.6893L8.52258 15.9874C8.44321 15.7461 8.25391 15.5568 8.01256 15.4774L4.31073 14.26C3.57731 14.0187 3.57731 12.9813 4.31073 12.74L8.01256 11.5226C8.25391 11.4432 8.44321 11.2539 8.52258 11.0126L9.74004 7.31073Z"
        fill={color}
      />
      <path
        d="M17.62 3.15536C17.7406 2.78865 18.2594 2.78865 18.38 3.15536L18.9268 4.81815C18.9665 4.93883 19.0612 5.03347 19.1818 5.07316L20.8446 5.62002C21.2113 5.74063 21.2113 6.25937 20.8446 6.37998L19.1818 6.92684C19.0612 6.96653 18.9665 7.06117 18.9268 7.18185L18.38 8.84464C18.2594 9.21135 17.7406 9.21135 17.62 8.84464L17.0732 7.18185C17.0335 7.06117 16.9388 6.96653 16.8182 6.92684L15.1554 6.37998C14.7887 6.25937 14.7887 5.74063 15.1554 5.62002L16.8182 5.07316C16.9388 5.03347 17.0335 4.93883 17.0732 4.81815L17.62 3.15536Z"
        fill={color}
      />
      <path
        d="M17.81 16.5777C17.8703 16.3943 18.1297 16.3943 18.19 16.5777L18.4634 17.4091C18.4833 17.4694 18.5306 17.5167 18.5909 17.5366L19.4223 17.81C19.6057 17.8703 19.6057 18.1297 19.4223 18.19L18.5909 18.4634C18.5306 18.4833 18.4833 18.5306 18.4634 18.5909L18.19 19.4223C18.1297 19.6057 17.8703 19.6057 17.81 19.4223L17.5366 18.5909C17.5167 18.5306 17.4694 18.4833 17.4091 18.4634L16.5777 18.19C16.3943 18.1297 16.3943 17.8703 16.5777 17.81L17.4091 17.5366C17.4694 17.5167 17.5167 17.4694 17.5366 17.4091L17.81 16.5777Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_545_57971">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </BaseSvg>
);
